


import { useContext, useEffect, useRef, useState } from "react";
import Select from "react-select";
import { ERROR_MESSAGES } from "../../components/common/GlobalMassssage";
import { globalSelectStyles } from "../../middleware/enum";
import { AuthContext, LoaderContext } from "../../Context/ContextFunctions";
import {
      AddUpdateLeave,
      GetLeaveModel,
} from "../../services/LeaveManagement/LeaveManage";
import { GetLeaveTypeLookupList } from "../../services/SettingApi/LeaveType/LeaveType";
import SuccessModal from "../../components/common/SuccessModal";

const leaveTypeOptions = [
      { value: 1, label: "Comp off" },
      { value: 2, label: "Referal" },
      { value: 3, label: "Casual Leave" },
      { value: 4, label: "Paid Leave" },
];

const AttendanceAddUpdateModal = ({
      isOpen,
      onClose,
      setIsAddUpdateDone,
      modelRequestData,
}) => {
      const [leaveData, setLeaveData] = useState({
            fromDate: "",
            toDate: "",
            isFullDay: true,
            leaveTypeID: null,
            remark: "",
      });
      const inputRef = useRef(null);
      const [requireErrorMessage, setRequireErrorMessage] = useState(false);
      const [showSuccessPopupModal, setShowSuccessPopupModal] = useState(false);
      const [errorMessage, setErrorMessage] = useState(false);
      const [modelAction, setModelAction] = useState("");
      const [leaveTypeLookupList, setLeaveTypeLookupList] = useState([]);
      const { authDetails, PanalModuleName } = useContext(AuthContext);
      const { setLoader } = useContext(LoaderContext);
      //Initial UseEffect
      useEffect(() => {
            GetLeaveTypeLookupListData();
            setErrorMessage("");
      }, []);
      //getModel
      useEffect(() => {
            setModelAction(modelRequestData.Action === null ? "Add" : "Update"); //Do not change this naming convention
            if (
                  modelRequestData.KeyID !== undefined &&
                  modelRequestData.KeyID !== null &&
                  modelRequestData.Action === "Update"
            ) {
                  GetLeaveModelData(modelRequestData.KeyID);
            } else {
                  setLeaveData({
                        fromDate: "",
                        toDate: "",
                        isFullDay: true,
                        leaveTypeID: null,
                        remark: "",
                  });
            }
            setErrorMessage("");
      }, [modelRequestData]);

      // 1) Leave Type Lookup List API
      const GetLeaveTypeLookupListData = async () => {
            try {
                  const data = await GetLeaveTypeLookupList(
                        PanalModuleName,
                        authDetails.userKeyID
                  );
                  if (data?.statusCode === 200 && data?.responseData?.data) {
                        const List = data.responseData.data.map((item) => ({
                              value: item.leaveTypeID, // Use leaveTypeID from the response
                              label: item.leaveTypeName, // Use leaveTypeName from the response
                        }));
                        setLeaveTypeLookupList(List);
                  }
            } catch (error) {
                  console.log(error);
            }
      };
      //Get Model
      const GetLeaveModelData = async (KeyID) => {
            setLoader(true);
            const data = await GetLeaveModel(
                  PanalModuleName,
                  KeyID,
                  authDetails.userKeyID
            );
            if (data.statusCode === 200) {
                  setLoader(false);
                  const ModalData = data.responseData.data;
                  setLeaveData({
                        fromDate: ModalData.fromDate.split("T")[0],
                        toDate: ModalData.toDate.split("T")[0],
                        isFullDay: ModalData.isFullDay,
                        leaveTypeID: ModalData.leaveTypeID,
                        remark: ModalData.remark,
                  });
                  console.log("Leave Data after fetching:", ModalData); // Debugging
            } else {
                  setLoader(false);
            }
      };
      // General update handler
      const updateField = (field, value) => {
            setLeaveData((prev) => ({ ...prev, [field]: value }));
      };

      // Handle Start Date selection
      const handleStartDateChange = (e) => {
            updateField("fromDate", e.target.value);
            updateField("toDate", ""); // Reset toDate on new start date selection
      };

      // Handle End Date selection
      const handleEndDateChange = async (e) => {
            if (leaveData.fromDate && e.target.value >= leaveData.fromDate) {
                  updateField("toDate", e.target.value);
            } else {
                  setErrorMessage(
                        "End date must be greater than or equal to the start date."
                  );
            }
      };

      const handleSubmit = async () => {
            if (
                  leaveData.fromDate === undefined ||
                  leaveData.fromDate === null ||
                  leaveData.fromDate === "" ||
                  leaveData.toDate === undefined ||
                  leaveData.toDate === null ||
                  leaveData.toDate === "" ||
                  leaveData.leaveTypeID === undefined ||
                  leaveData.leaveTypeID === null ||
                  leaveData.leaveTypeID === "" ||
                  leaveData.remark === undefined ||
                  leaveData.remark === null ||
                  leaveData.remark === ""
            ) {
                  setRequireErrorMessage(true);
                  return false;
            }
            setLoader(true);
            try {
                  const data = await AddUpdateLeave({
                        userKeyID: authDetails.userKeyID,
                        leaveKeyID: modelRequestData.KeyID,
                        leaveTypeID: leaveData.leaveTypeID,
                        isFullDay: leaveData.isFullDay,
                        fromDate: leaveData.fromDate,
                        toDate: leaveData.toDate,
                        remark: leaveData.remark,
                        ModuleName: PanalModuleName,
                  });
                  if (data?.statusCode === 200) {
                        setLoader(false);
                        setIsAddUpdateDone(true);
                        setShowSuccessPopupModal(true);
                  } else {
                        setLoader(false);
                        const errorMessage = data?.response?.data?.errorMessage;
                        setErrorMessage(errorMessage);
                  }
            } catch (error) {
                  setLoader(false);
            }
      };

      return (
            <div className="fixed inset-0 flex items-center justify-center z-50">
                  <div
                        className="bg-white w-full max-w-lg md:max-w-2xl lg:max-w-3xl rounded-lg shadow-lg overflow-hidden max-h-[90vh] flex flex-col"
                        onClick={(e) => e.stopPropagation()}
                  >
                        {/* Modal Header */}
                        <div className="bg-[#ECF6FF] text-black p-4 flex justify-between items-center">
                              <h2 className="text-16 font-semibold">Attendance Management</h2>
                              <button onClick={onClose} className="text-black text-16">
                                    &times;
                              </button>
                        </div>

                        {/* Form Section */}
                        <div className="p-5 flex flex-col gap-4 text-12 overflow-y-auto">
                              {/* Leave Type and Select Duration side by side */}
                              <div className="flex flex-col md:flex-row gap-4">
                                    {/* Leave Type */}
                                    <div className="flex-1">
                                          <label className="block font-medium text-gray-700 mb-1">
                                                Employee Name<span style={{ color: "red" }}>*</span>
                                          </label>
                                          <Select
                                                value={
                                                      leaveTypeLookupList.find(
                                                            (option) => option.value === leaveData.leaveTypeID
                                                      ) || null
                                                }
                                                onChange={(selectedOption) =>
                                                      updateField("leaveTypeID", selectedOption?.value)
                                                }
                                                options={leaveTypeLookupList} // Use the state here
                                                placeholder="Select Employee"
                                                className="text-sm"
                                                classNamePrefix="react-select"
                                                styles={globalSelectStyles}
                                          />
                                          {requireErrorMessage &&
                                                (leaveData.leaveTypeID === "" ||
                                                      leaveData.leaveTypeID === undefined ||
                                                      leaveData.leaveTypeID === null) ? (
                                                <label className="validation">{ERROR_MESSAGES}</label>
                                          ) : (
                                                ""
                                          )}
                                    </div>

                                    {/* Select Duration */}
                                    <div className="flex-1">
                                          <label className="block font-medium text-gray-700 mb-1">
                                                Date <span style={{ color: "red" }}>*</span>
                                          </label>
                                          <input
                                                type="date"
                                                value={leaveData.fromDate}
                                                onChange={handleStartDateChange}
                                                min={new Date().toISOString().split("T")[0]}
                                                className="w-full border rounded-md px-3 py-2 focus:ring focus:ring-blue-200"
                                          />
                                          {requireErrorMessage &&
                                                (leaveData.fromDate === "" ||
                                                      leaveData.fromDate === undefined ||
                                                      leaveData.fromDate === null) ? (
                                                <label className="validation">{ERROR_MESSAGES}</label>
                                          ) : (
                                                ""
                                          )}
                                    </div>
                              </div>

                              {/* Date & Type Fields in a row */}
                              <div className="flex flex-col md:flex-row gap-4">
                                    {/* Start Date */}
                                    <div className="flex-1">
                                          <label className="block font-medium text-gray-700 mb-1">
                                                Role <span style={{ color: "red" }}>*</span>
                                          </label>
                                          <Select

                                                placeholder='Role'
                                          />
                                          {requireErrorMessage &&
                                                (leaveData.fromDate === "" ||
                                                      leaveData.fromDate === undefined ||
                                                      leaveData.fromDate === null) ? (
                                                <label className="validation">{ERROR_MESSAGES}</label>
                                          ) : (
                                                ""
                                          )}
                                    </div>
                                    <div className="flex-1">
                                          <label className="block font-medium text-gray-700 mb-1">
                                                Location <span style={{ color: "red" }}>*</span>
                                          </label>
                                          <Select

                                                placeholder='Location'
                                          />
                                          {requireErrorMessage &&
                                                (leaveData.fromDate === "" ||
                                                      leaveData.fromDate === undefined ||
                                                      leaveData.fromDate === null) ? (
                                                <label className="validation">{ERROR_MESSAGES}</label>
                                          ) : (
                                                ""
                                          )}
                                    </div>

                                    {/* End Date */}

                              </div>
                              <div className="flex flex-col md:flex-row gap-4">
                                    {/* Start Date */}
                                    <div className="flex-1">
                                          <label className="block font-medium text-gray-700 mb-1">
                                                Check-in Time <span style={{ color: "red" }}>*</span>
                                          </label>
                                          <input
                                                type="time"
                                                value={leaveData.fromDate}
                                                onChange={handleStartDateChange}
                                                min={new Date().toISOString().split("T")[0]}
                                                className="w-full border rounded-md px-3 py-2 focus:ring focus:ring-blue-200"
                                          />
                                          {requireErrorMessage &&
                                                (leaveData.fromDate === "" ||
                                                      leaveData.fromDate === undefined ||
                                                      leaveData.fromDate === null) ? (
                                                <label className="validation">{ERROR_MESSAGES}</label>
                                          ) : (
                                                ""
                                          )}
                                    </div>

                                    {/* End Date */}
                                    <div className="flex-1">
                                          <label className="block font-medium text-gray-700 mb-1">
                                                Check-out Time <span style={{ color: "red" }}>*</span>
                                          </label>
                                          <input
                                                type="time"
                                                value={leaveData.toDate}
                                                onChange={handleEndDateChange}
                                                min={leaveData.fromDate}
                                                className="w-full border rounded-md px-3 py-2 focus:ring focus:ring-blue-200"
                                          />
                                          {requireErrorMessage &&
                                                (leaveData.toDate === "" ||
                                                      leaveData.toDate === undefined ||
                                                      leaveData.toDate === null) ? (
                                                <label className="validation">{ERROR_MESSAGES}</label>
                                          ) : (
                                                ""
                                          )}
                                    </div>
                              </div>
                              {/* job and expens */}

                              <div className="flex flex-col md:flex-row gap-4">
                                    {/* Leave Type */}
                                    <div className="flex-1">
                                          <label className="block font-medium text-gray-700 mb-1">
                                                Status<span style={{ color: "red" }}>*</span>
                                          </label>
                                          <Select
                                                value={
                                                      leaveTypeLookupList.find(
                                                            (option) => option.value === leaveData.leaveTypeID
                                                      ) || null
                                                }
                                                onChange={(selectedOption) =>
                                                      updateField("leaveTypeID", selectedOption?.value)
                                                }
                                                options={leaveTypeLookupList} // Use the state here
                                                placeholder="Select Job"
                                                className="text-sm"
                                                classNamePrefix="react-select"
                                                styles={globalSelectStyles}
                                          />
                                          {requireErrorMessage &&
                                                (leaveData.leaveTypeID === "" ||
                                                      leaveData.leaveTypeID === undefined ||
                                                      leaveData.leaveTypeID === null) ? (
                                                <label className="validation">{ERROR_MESSAGES}</label>
                                          ) : (
                                                ""
                                          )}
                                    </div>

                                    {/* Select Duration */}
                                    <div className="flex-1">
                                          <label className="block font-medium text-gray-700 mb-1">
                                                Status <span style={{ color: "red" }}>*</span>
                                          </label>
                                          <Select
                                                placeholder="Enter Status"
                                          />
                                          {requireErrorMessage &&
                                                (leaveData.fromDate === "" ||
                                                      leaveData.fromDate === undefined ||
                                                      leaveData.fromDate === null) ? (
                                                <label className="validation">{ERROR_MESSAGES}</label>
                                          ) : (
                                                ""
                                          )}
                                    </div>
                              </div>

                              {/* Note */}

                        </div>
                        {errorMessage && (
                              <div className="text-center">
                                    <label className="validation ">{errorMessage}</label>
                              </div>
                        )}
                        {/* Footer Buttons */}
                        <div className="bg-gray-100 p-4 flex justify-end space-x-2">
                              <button
                                    onClick={onClose}
                                    className="mx-2 px-4 py-2 bg-gray-300 rounded-md text-12"
                              >
                                    Cancel
                              </button>
                              <button
                                    onClick={handleSubmit}
                                    className="bg-gradient-to-r from-[#0E4C84] to-[#00A7C1] hover:from-[#135EA0] hover:to-[#00B8D4] text-white px-5 py-2 rounded-lg text-12 font-medium shadow-md shadow-cyan-500/30 hover:shadow-cyan-400/40 transition-all duration-300"
                              >
                                    Submit
                              </button>
                        </div>
                  </div>
                  <SuccessModal
                        isOpen={showSuccessPopupModal}
                        onClose={() => {
                              onClose();
                              setShowSuccessPopupModal(false);
                        }}
                        modelAction={modelAction}
                        actionMessage={
                              leaveTypeLookupList.find(
                                    (option) => option.value === leaveData.leaveTypeID
                              )?.label
                        }
                  />
            </div>
      );
};

export default AttendanceAddUpdateModal;
